import React from "react";
import { FONT_HOSTING_DATA, DEFAULT_ROBOT_FONT_FAMILY } from "constants/fonts";

const STATIC_FONTS_KIT_ID = "sya2bsw";

const FontsComponent = (props) => {
  const { pagePath, fontFamily } = props;

  const getAdobeTypekitURL = (adobeFontKitId) => {
    return `https://use.typekit.net/${adobeFontKitId}.css`;
  };

  const getAdobeStaticURL = () => {
    return `/static/fonts/${STATIC_FONTS_KIT_ID}.css`;
  };

  const getGoogleFontsURL = (fontFamily) => {
    return `//fonts.googleapis.com/css?family=${fontFamily}`;
  };

  const gettypekitScriptAsync = (kitId) => {
    return `(function(d) {
      var config = {
        kitId: '${kitId}',
        scriptTimeout: 3000,
        async: true
      },
      h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);`;
  };

  const shouldOverrideFonts = () => {
    //	todo: set ab test here if needed, or delete
    return pagePath && pagePath.includes("/test/fonts");
  };

  const renderFontFromAdobeCloud = (fontFamilyToUse) => {
    const fontHostData = FONT_HOSTING_DATA[fontFamilyToUse];
    const { adobeFontKitId, asyncAdobeFontKitId } = fontHostData;

    if (shouldOverrideFonts()) {
      return <link rel="preload" rel="stylesheet" href={getAdobeStaticURL()} as="font" />;
    }

    return (
      <>
        {adobeFontKitId && <link rel="preload" rel="stylesheet" href={getAdobeTypekitURL(adobeFontKitId)} as="font" />}
        {asyncAdobeFontKitId && (
          <script
            dangerouslySetInnerHTML={{
              __html: gettypekitScriptAsync(asyncAdobeFontKitId)
            }}
          />
        )}
      </>
    );
  };

  const renderFontFromGoogleFonts = (fontFamilyToUse) => {
    return <link href={getGoogleFontsURL(fontFamilyToUse)} rel="stylesheet" type="text/css" />;
  };

  const isFontInAdobeCloud = (fontFamilyToUse) => {
    return (
      FONT_HOSTING_DATA[fontFamilyToUse] &&
      (FONT_HOSTING_DATA[fontFamilyToUse].adobeFontKitId || FONT_HOSTING_DATA[fontFamilyToUse].asyncAdobeFontKitId)
    );
  };

  return isFontInAdobeCloud(fontFamily) ? renderFontFromAdobeCloud(fontFamily) : renderFontFromGoogleFonts(fontFamily);
};

FontsComponent.defaultProps = {
  fontFamily: DEFAULT_ROBOT_FONT_FAMILY
};

export default FontsComponent;